<template>
    <div id="payment-method-page">
        <!-- White Box Section -->
        <section class="section-style margin-top-110">
            <div class="container padding-right-left-0">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-7">
                        <div class="box-form bg-white box-shadow rounded text-center">
                            <h1 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md text-center">Payment options</h1>
                            <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt.</p>
                            <div class="row">
                                <div class="col-12 col-sm-6 margin-top-30">
                                    <a href="#" target="_blank" class="border border-4 rounded padding-10 h-100 d-block box-link border-green">
                                        <p class="bd-title default-letter-spacing text-uppercase font-weight-bold font-md margin-top-10 margin-bottom-0">Borderless</p>
                                        <p class="font-md margin-top-10 margin-bottom-0 line-through">$50,000</p>
                                        <p class="bd-title default-letter-spacing text-uppercase font-weight-bold font-md margin-top-10 margin-bottom-0">$49,500</p>
                                    </a>
                                </div>
                                <div class="col-12 col-sm-6 margin-top-30">
                                    <a href="#" target="_blank" class="border border-4 rounded padding-10 h-100 d-block box-link">
                                        <p class="bd-title default-letter-spacing text-uppercase font-weight-bold font-md margin-top-10 margin-bottom-0">Credit Card</p>
                                        <p class="bd-title default-letter-spacing text-uppercase font-weight-bold font-md margin-top-10 margin-bottom-0">$50,000</p>
                                    </a>
                                </div>
                                <div class="col-12 margin-top-30">
                                    <div class="border border-4 rounded padding-20">
                                        <p class="bd-title default-letter-spacing text-uppercase font-weight-bold font-md margin-top-10 margin-bottom-0">Wire</p>
                                        <p class="bd-title default-letter-spacing text-uppercase font-weight-bold font-md margin-top-10 margin-bottom-0">$50,000</p>
                                        <div class="margin-top-20 text-left">
                                            <p class="margin-bottom-5"><strong>Bank:</strong> Synovus 1048 Broadway Columbus, GA 31901</p>
                                            <p class="margin-bottom-5"><strong>Routing/ABA #:</strong> 061100606</p>
                                            <p class="margin-bottom-5"><strong>SWIFT Code:</strong> FICOUS44</p>
                                            <p class="margin-bottom-5"><strong>Beneficiary Account Number:</strong> 1054586700</p>
                                            <p class="margin-bottom-5"><strong>Beneficiary Name:</strong>Ultimate Jet Vacations, LLC.<br>2420 NE Miami Gardens Dr. Ste.410 Miami, FL, 33180</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 margin-top-20">
                                    <div class="alert alert-success padding-10 mw-100" role="alert">
                                        Please contact your designated Travel Advisor in order to complete payment via Wire Transfer.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-7">
                        <div class="box-form bg-white box-shadow rounded text-center">
                            <h1 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md text-center">Reservation summary</h1>
                            <div class="text-left table-responsive-lg">
                                <table class="table table-striped">
                                    <thead>
                                    <tr>
                                        <th scope="col">Booking No.</th>
                                        <th scope="col">Total Due</th>
                                        <th scope="col">Total Paid</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>35464565</td>
                                        <td>$13,500.00</td>
                                        <td>$500.00</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
    export default {
    }
</script>
<style lang="scss">
    .border-4{
        border-width: 4px !important;
    }
    .line-through{
        text-decoration: line-through;
    }
    .border-green{
        border-color: #48bb78 !important;
    }
    .box-link{
        color: inherit;
        &:hover{
            background-color: #48bb78;
            text-decoration: none;
            color: white;
            border-color: #48bb78 !important;
        }
    }
</style>